













































































import { Component, Vue, Prop } from 'vue-property-decorator';
import * as Common from '@/tenantCatalog/common';
import * as Components from '@/tenantCatalog/components';
import Moment from 'moment';

@Component
export default class PartnerPaymentView extends Vue {
  public items: Common.PartnerPayment[] = new Array(0);
  public params: Common.PartnerPaymentQuery = new Common.PartnerPaymentQuery();
  public exportQuery = new Common.ExportQuery('パートナー支払', this.params);

  public sortOptions: any = [{ value: 'tenantId', text: 'テナントID' },{ value: 'tenantName', text: 'テナント名称' }];
  @Prop() public tenantId:string;
  @Prop() public dueDate:Date;

  public created(){
    if (this.tenantId) this.params.tenantId = this.tenantId;
    if (this.dueDate) this.params.dueDate = this.dueDate;
  }

  public executeFile(){

    const items =(this.$refs.mainList as Components.ListView).selectedItems as Common.PartnerPayment[];    
    if (items.length == 0) {
       this.$api.modal.show('パートナー支払ファイル','対象のレコードを選択してください。',true,null);
       return;
    }

    this.$api.modal.show("パートナー支払ファイル","パートナー支払ファイルを出力してよろしいですか？",false,()=>{
        //①全銀ファイルを出力する
        var exportQuery = new Common.PartnerPaymentFileExportQuery("パートナー支払ファイル", items);
        this.$api.download(exportQuery);
    });    
  }
  public onWorkflow(index: number, obj: any) {
    this.$set(this.items, index, obj); 
  }  
  public showTenant(tenantId:string){
      this.$router.push(String.format('/project/tenant?tenantId={0}',tenantId));
  }  
}
